import { render } from "./DragAndDrop.vue?vue&type=template&id=72d317ea&scoped=true"
const script = {}

import "./DragAndDrop.vue?vue&type=style&index=0&id=72d317ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72d317ea"

export default script